import React from 'react'
import Icon from '../../atoms/Icon/Icon'
import { Book, Download } from '../../atoms/NewIcons'

const CatalogoCard = ({ img, title, description }) => {
  return (
    <div className="catalogo-card">
      <img className="catalogo-card__image" src={img} />
      <div className="catalogo-card__content">
        <p className="catalogo-card__title">{title}</p>
        <p className="catalogo-card__description">{description}</p>
        <div className="catalogo-card__buttons">
          <a className="catalogo-card__button">
            <span className="catalogo-card__button-icon">
              <Download />
            </span>
            <span className="catalogo-card__button-label">Scarica</span>
          </a>
          <a className="catalogo-card__button">
            <span className="catalogo-card__button-icon">
              <Book />
            </span>
            <span className="catalogo-card__button-label">Sfoglia</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default CatalogoCard
